import React from "react"
import {getCustomerId, getTenantId} from "../../utils/Routes"
import {useLocation} from "react-router-dom"
var tenantQueryParam: string = "&tenant_id=" + getTenantId()
const Document = () => {
	useLocation()

	const iframeSrc = `${
		process.env.REACT_APP_CARE_DESIGN_UI
	}/?shopper_id=${getCustomerId()}${tenantQueryParam}`
	return (
		<div>
			<iframe key={iframeSrc} src={iframeSrc} title="Designer" width={"100%"} height="2000px" />
		</div>
	)
}

export default Document
